import axiosPrivate from "@services/axiosPrivate";
import { CUSTOM_OUTSTANDING_URL } from "src/constants";

export const getCustomOutstandingPayment = (data) => {
  return axiosPrivate.post(CUSTOM_OUTSTANDING_URL, data, {
    withCredentials: true,
  });
};
